"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Units = void 0;
const bignumber_js_1 = require("bignumber.js");
class Units {
    constructor() { }
    /**
     * Parse from specific units and return a BigNumber
     * @param n number
     * @param decimals decimals
     */
    static parse(n, decimals) {
        return (0, bignumber_js_1.BigNumber)(n).shiftedBy(decimals);
    }
    /**
     * Format in specific units and return a BigNumber
     * @param n number
     * @param decimals decimals
     */
    static format(n, decimals) {
        return (0, bignumber_js_1.BigNumber)(n).shiftedBy(-decimals);
    }
}
exports.Units = Units;
//# sourceMappingURL=Units.js.map